import { h } from 'preact';
import { useWindowSize } from '../utils/window-size';
import ColumnComponentDesktop from './column-component-desktop';
import ColumnComponentMobile from './column-component-mobile';

const ColumnComponent = ({
  data,
  index,
  isActive,
  setActiveItem,
}) => {
  const { isTabletOrSmaller } = useWindowSize();

  return isTabletOrSmaller ? (
    <ColumnComponentMobile
    data={data}
    index={index}
    isActive={isActive}
    setActiveItem={setActiveItem} />
  ) : (
    <ColumnComponentDesktop
      data={data}
      index={index}
      isActive={isActive}
      setActiveItem={setActiveItem} />
  );
};

export default ColumnComponent;